/**
 * @fileoverview POST handler for the "/app_settings/authentication_credential/delete" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAuthenticationCredentialDeleteCacheKeys } from "./constants";
import type {
  PostAppSettingsAuthenticationCredentialDeleteProps,
  AppSettingsAuthenticationCredentialDeleteResult,
} from "./types";

export const postAppSettingsAuthenticationCredentialDelete = reactQueryMutationAdapter(
  appSettingsAuthenticationCredentialDeleteCacheKeys,
  ({
    id,
  }: PostAppSettingsAuthenticationCredentialDeleteProps): Promise<AppSettingsAuthenticationCredentialDeleteResult> => {
    const params = {
      credential_id: id,
    };

    return fetch("/app_settings/authentication_credential/delete", "POST", params);
  }
);
